export default "__VITE_ASSET__6d88438a__"